module.exports = __webpack_public_path__ + "static/assets/ee57a2d2ee8660a1e8c6a4a66bbc802f.png";